module.exports = {
  email: 'contact@draatalents.org',

  socialMedia: [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/groups/1190447628207222/',
    },
    {
      name: 'Twitter',
      url: 'https://x.com/connectmit2024',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/connectmit2030/',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/groups/12720938',
    },
  ],

  navLinks: [
    {
      name: 'Home',
      url: '/#home',
    },
    {
      name: 'Services',
      url: '/#services',
    },
    {
      name: 'About Us',
      url: '/#about',
    },
    {
      name: 'Contact Us',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#0099ff',
    navy: '#001f3f',
    darkNavy: '#0a192f',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
